var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"content-class":"preview-signed-note-root-preview","max-width":"80%","width":"1100"},on:{"click:outside":_vm.onClosePreview},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('SignedVisitNote',{attrs:{"item":_vm.signedNote}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }